import * as Blockly from 'blockly/core'
import { luaGenerator, Order } from 'blockly/lua'

// 全角を半角に変換する関数
const convertFullWidthToHalfWidth = (str: string): string => {
  return str
    .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
    .replace(/[Ｅｅ]/g, 'e')
    .replace(/[。.]/g, '.')
    .replace(/[‐－―ー]/g, '-')
}

// 型ガード
function isBlocklyFieldInput(
  element: HTMLInputElement,
): element is HTMLInputElement & {
  field_: { setValue: (value: string | number) => void }
} {
  const field = (element as { field_?: unknown }).field_
  return (
    typeof field === 'object' &&
    field !== null &&
    'setValue' in field &&
    typeof (field as { setValue?: unknown }).setValue === 'function'
  )
}

function updateBlocklyInput(input: HTMLInputElement) {
  const originalValue = input.value
  const convertedValue = convertFullWidthToHalfWidth(originalValue)
  // 元の値と変換後の値が異なる場合のみ処理
  if (originalValue !== convertedValue) {
    // カーソル位置を保存して更新
    const cursor = input.selectionStart || 0
    // 値を更新
    input.value = convertedValue
    // カーソル位置を復元
    input.setSelectionRange(cursor, cursor)
    // Blockly FieldNumber に値を反映
    if (isBlocklyFieldInput(input)) {
      try {
        input.field_.setValue(convertedValue)
      } catch (error) {
        console.warn('Blockly field update failed:', error)
      }
    }
    // input イベントを発火
    input.dispatchEvent(new Event('input', { bubbles: true }))
  }
}

// ページロード完了時に初期化する
window.addEventListener(
  'load',
  () => {
    // math_integerブロックのコード生成機能を定義
    luaGenerator.forBlock['math_integer'] = function (block) {
      const number = Number(block.getFieldValue('NUM'))
      return [number.toString(), Order.ATOMIC]
    }
  },
  { once: true },
)

// Blocklyが使用するDOM要素に対するイベントリスナー
let isComposing = false

document.addEventListener(
  'compositionstart',
  () => {
    isComposing = true
  },
  { capture: true },
)

document.addEventListener(
  'compositionend',
  (e) => {
    isComposing = false
    if (
      e.target instanceof HTMLInputElement &&
      e.target.classList.contains('blocklyHtmlInput')
    ) {
      updateBlocklyInput(e.target)
    }
  },
  { capture: true },
)

document.addEventListener(
  'input',
  (e) => {
    if (isComposing) return // IME入力中はスキップ
    if (
      e.target instanceof HTMLInputElement &&
      e.target.classList.contains('blocklyHtmlInput')
    ) {
      updateBlocklyInput(e.target)
    }
  },
  { capture: true },
) // キャプチャフェーズで処理（優先度を高く）

document.addEventListener(
  'keydown',
  (e) => {
    if (
      e.key === 'Enter' &&
      e.target instanceof HTMLInputElement &&
      e.target.classList.contains('blocklyHtmlInput')
    ) {
      updateBlocklyInput(e.target)
    }
  },
  { capture: true },
)

document.addEventListener(
  'pointerdown',
  (e) => {
    const activeInput = document.activeElement
    if (
      activeInput instanceof HTMLInputElement &&
      activeInput.classList.contains('blocklyHtmlInput') &&
      e.target !== activeInput
    ) {
      updateBlocklyInput(activeInput)
    }
  },
  { capture: true },
)

// math_integerブロックの定義
// 一般的なBlockly定義手法を使用
Blockly.Blocks['math_integer'] = {
  init: function () {
    this.jsonInit({
      type: 'math_integer',
      message0: '%1',
      args0: [
        {
          type: 'field_number',
          name: 'NUM',
          value: 0,
          precision: 1, // 整数のみ
        },
      ],
      output: 'Number',
      colour: 230,
    })
  },
}
